module.exports = __webpack_public_path__ + "static/media/cancel-upload.f8a2673e.svg";